import { render, staticRenderFns } from "./DataCollectionPolicy.vue?vue&type=template&id=fd6af526&"
import script from "./DataCollectionPolicy.vue?vue&type=script&lang=ts&"
export * from "./DataCollectionPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./DataCollectionPolicy.vue?vue&type=style&index=0&id=fd6af526&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports